import { getField, updateField } from "vuex-map-fields";
import { settingService } from "@/services";
import { EventBus } from "@/helpers";
import { USER_TYPE } from "@/const";

export const setting = {
  namespaced: true,
  state: {
    pilots: [],
    drones: [],
    projects: [],
    pilotQuantity: 0,
    droneQuantity: 0,

    airspaceGeoData: {
      type: "FeatureCollection",
      name: "airspaces",
      features: []
    },
    airspaceAboveSFCGeoData: {
      type: "FeatureCollection",
      name: "airspaces_above_src",
      features: []
    }, 
    aerodromeGeoData: {
      type: "FeatureCollection",
      name: "aerodromes",
      features: []
    },
    heliportGeoData: {
      type: "FeatureCollection",
      name: "heliports",
      features: []
    },

    droneMaintenance: [],
    pilotTraining: [],

    showAirspace: true,
    showAirspaceAboveSFC: false,
    showAerodrome: true
  },
  actions: {
    getSettings(context) {
      return settingService
        .getSettings()
        .then(response => {
          console.log(response);
          context.commit("setSettings", {
            response
          });
          if (
            this.state.auth.usertype === USER_TYPE.ADMIN ||
            this.state.auth.usertype === USER_TYPE.ENTERPRISE ||
            this.state.auth.usertype === USER_TYPE.SUPER
          ) {
            context.dispatch("getPilotTraining");
            context.dispatch("getDroneMaintenance");
          }
        })
        .catch(error => {
          console.log("Error getSettings: ", error);
          EventBus.$emit("failedGetSettings", error);
        });
    },

    getGeoData(context, payload) {
      return settingService
        .getGeoData(payload.lng, payload.lat)
        .then(response => {
          console.log(response);
          context.commit("setGeoData", {
            response
          });
        })
        .catch(error => {
          console.log("Error getGeoData: ", error);
          EventBus.$emit("failedGetGeoData", error);
        });
    },
    addPilot(context, payload) {
      return settingService
        .addPilot(payload)
        .then(response => {
          console.log(response);
          if (response.error) {
            EventBus.$emit("failedPilotAccess", response.error);
          } else {
            context.dispatch("getSettings");
          }
        })
        .catch(error => {
          console.log("Error addPilot: ", error);
          EventBus.$emit("failedAddPilot", error);
        });
    },
    updatePilot(context, payload) {
      return settingService
        .updatePilot(payload.position, payload)
        .then(response => {
          console.log(response);
          if (response.error) {
            EventBus.$emit("failedPilotAccess", response.error);
          } else {
            context.dispatch("getSettings");
          }
        })
        .catch(error => {
          console.log("Error updatePilot: ", error);
          EventBus.$emit("failedUpdatePilot", error);
        });
    },
    deletePilot(context, payload) {
      return settingService
        .deletePilot(payload.position)
        .then(response => {
          console.log(response);
          context.dispatch("getSettings");
        })
        .catch(error => {
          console.log("Error deletePilot: ", error);
          EventBus.$emit("failedDeletePilot", error);
        });
    },
    addDrone(context, payload) {
      return settingService
        .addDrone(payload)
        .then(response => {
          console.log(response);
          context.dispatch("getSettings");
        })
        .catch(error => {
          console.log("Error addDrone: ", error);
          EventBus.$emit("failedAddDrone", error);
        });
    },
    updateDrone(context, payload) {
      return settingService
        .updateDrone(payload.position, payload)
        .then(response => {
          console.log(response);
          context.dispatch("getSettings");
        })
        .catch(error => {
          console.log("Error updateDrone: ", error);
          EventBus.$emit("failedUpdateDrone", error);
        });
    },
    deleteDrone(context, payload) {
      return settingService
        .deleteDrone(payload.position)
        .then(response => {
          console.log(response);
          context.dispatch("getSettings");
        })
        .catch(error => {
          console.log("Error deleteDrone: ", error);
          EventBus.$emit("failedDeleteDrone", error);
        });
    },
    addProject(context, payload) {
      return settingService
        .addProject(payload)
        .then(response => {
          console.log(response);
          context.dispatch("getSettings");
        })
        .catch(error => {
          console.log("Error addProject: ", error);
          EventBus.$emit("failedAddProject", error);
        });
    },
    updateProject(context, payload) {
      return settingService
        .updateProject(payload.position, payload)
        .then(response => {
          console.log(response);
          context.dispatch("getSettings");
        })
        .catch(error => {
          console.log("Error updateProject: ", error);
          EventBus.$emit("failedUpdateProject", error);
        });
    },
    deleteProject(context, payload) {
      return settingService
        .deleteProject(payload.position)
        .then(response => {
          console.log(response);
          context.dispatch("getSettings");
        })
        .catch(error => {
          console.log("Error deleteProject: ", error);
          EventBus.$emit("failedDeleteProject", error);
        });
    },
    getDroneMaintenance(context) {
      return settingService
        .getDroneMaintenance()
        .then(response => {
          console.log(response);
          context.commit("setDroneMaintenance", {
            response
          });
        })
        .catch(error => {
          console.log("Error getDroneMaintenance: ", error);
          EventBus.$emit("failedGetDroneMaintenance", error);
        });
    },
    addDroneMaintenance(context, payload) {
      return settingService
        .addDroneMaintenance(payload)
        .then(response => {
          console.log(response);
          this.dispatch("stats/getDroneCurrentHours");
          this.dispatch("stats/getDroneTotalHours");
          context.dispatch("getDroneMaintenance");
        })
        .catch(error => {
          console.log("Error addDroneMaintenance: ", error);
          EventBus.$emit("failedAddDroneMaintenance", error);
        });
    },
    getPilotTraining(context) {
      return settingService
        .getPilotTraining()
        .then(response => {
          console.log(response);
          context.commit("setPilotTraining", {
            response
          });
        })
        .catch(error => {
          console.log("Error getPilotTraining: ", error);
          EventBus.$emit("failedGetPilotTraining", error);
        });
    },
    addPilotTraining(context, payload) {
      return settingService
        .addPilotTraining(payload)
        .then(response => {
          console.log(response);
          context.dispatch("getPilotTraining");
        })
        .catch(error => {
          console.log("Error addPilotTraining: ", error);
          EventBus.$emit("failedAddPilotTraining", error);
        });
    }
  },
  mutations: {
    updateField,
    setSettings(state, payload) {
      console.log("setSettings payload = ", payload);
      if (payload.response.data !== "null") {
        var obj = JSON.parse(payload.response.data);
        state.pilots = obj.pilots === undefined ? [] : obj.pilots;
        state.drones = obj.drones === undefined ? [] : obj.drones;
        state.projects = obj.projects === undefined ? [] : obj.projects;
      }

      state.pilotQuantity = 0;
      state.pilots.forEach(pilot => {
        if (pilot.pilot) {
          state.pilotQuantity++;
        }
      });

      state.droneQuantity = 0;
      state.drones.forEach(drone => {
        if (drone.manufacturer) {
          state.droneQuantity++;
        }
      });
    },
    setGeoData(state, payload) {
      state.airspaceGeoData = {
        type: "FeatureCollection",
        name: "airspaces",
        crs: {
          type: "name",
          properties: { name: "urn:ogc:def:crs:OGC:1.3:CRS84" }
        },
        features: JSON.parse(payload.response.data.airspace)
      };
      state.airspaceAboveSFCGeoData = {
        type: "FeatureCollection",
        name: "airspaces_above_sfc",
        crs: {
          type: "name",
          properties: { name: "urn:ogc:def:crs:OGC:1.3:CRS84" }
        },
        features: JSON.parse(payload.response.data.airspace_above_src)
      }; 
      // store id to properties
      let aerodromeGeoData = JSON.parse(payload.response.data.aerodrome)
      aerodromeGeoData.map((item, idx) => {
        item.properties.id = item.id
        return item
      })
      state.aerodromeGeoData = {
        type: "FeatureCollection",
        name: "aerodromes",
        features: aerodromeGeoData
      };

      let heliportGeoData = JSON.parse(payload.response.data.heliport)
      heliportGeoData.map((item, idx) => {
        item.properties.id = item.id
        return item
      })
      state.heliportGeoData = {
        type: "FeatureCollection",
        name: "heliports",
        features: heliportGeoData
      };
      EventBus.$emit("setGeoData");
    },
    setDroneMaintenance(state, payload) {
      console.log("setDroneMaintenance payload = ", payload);
      if (payload.response.data) {
        state.droneMaintenance = JSON.parse(payload.response.data);
      }
      EventBus.$emit("getDroneMaintenance");
    },
    setPilotTraining(state, payload) {
      console.log("setPilotTraining payload = ", payload);
      if (payload.response.data) {
        state.pilotTraining = JSON.parse(payload.response.data);
      }
      EventBus.$emit("getPilotTraining");
    },
    setShowAirspaceAboveSFC(state, payload) {
      state.showAirspaceAboveSFC = payload
    }
  },
  getters: {
    getField
  }
};
